import { render } from "./TaskForm.vue?vue&type=template&id=2203ef60&ts=true"
import script from "./TaskForm.vue?vue&type=script&lang=ts"
export * from "./TaskForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/usuario/Documents/R/cursos/fstck/mevn-01/mevn-typescript/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__